import TextField from "@mui/material/TextField";
import Box from "@mui/material/Box";
import type { ChangeEvent } from "react";
import { useSearchParams } from "react-router-dom";
import { useDebounce } from "use-debounce";
import { useEffect, useState } from "react";
import { cmmsTheme } from "@setup/theme/cmms-theme";

export const SearchFilter = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const search = searchParams.get("search") ?? "";

	const [localSearchText, setLocalSearchText] = useState(search);
	const [debouncedSearchText] = useDebounce(localSearchText, 400);

	useEffect(() => {
		setLocalSearchText(search);
	}, [search]);

	useEffect(() => {
		if (debouncedSearchText !== search) {
			searchParams.set("search", debouncedSearchText);
			setSearchParams(searchParams, { replace: true });
		}
	}, [debouncedSearchText, searchParams, setSearchParams, search]);

	const handleFilter = (e: ChangeEvent<HTMLInputElement>) => {
		setLocalSearchText(e.target.value);
	};

	return (
		<Box position="relative">
			<TextField
				style={{ borderTopLeftRadius: 3, borderTopRightRadius: 3 }}
				label="Search"
				variant="outlined"
				margin="dense"
				value={localSearchText}
				onChange={handleFilter}
				fullWidth
				autoComplete="off"
				slotProps={{
					input: {
						style: { paddingRight: 45, height: cmmsTheme.dimensions.standardInput, marginTop: cmmsTheme.spacing.inputOffset }
					}
				}} />
			<i
				className="fa fa-search"
				style={{
					position: "absolute",
					right: 17,
					top: 20,
					cursor: "pointer",
				}} />
		</Box>
	);
};
